import { Button, Grid, ListItemText, Paper, Stack, TextField } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import React, { useEffect, useState } from 'react';
import AthleteDisplay from './AthleteDisplay';
import { useAtomValue, useSetAtom } from 'jotai';
import { Athlete } from '../atoms/athlete';
import { nationsAtom } from '../atoms/nationsAtom';
import { athletesAtom } from '../atoms/athletesAtom';
import { Api } from '../providers/Api';
import AddAthlete from './AddAthlete';

const ListAllAthletes = () => {
    const nations = useAtomValue(nationsAtom);
    const athletes = useAtomValue(athletesAtom);
    const setNations = useSetAtom(nationsAtom);
    const setAthletes = useSetAtom(athletesAtom);

    const [natFilter, setNatFilter] = useState('');
    const [athFilter, setAthFilter] = useState('');
    
    const [showAddAthlete, setShowAddAthlete] = useState(null);

    const [selAthlete, setSelAthlete] = useState(null as Athlete);

    const updateAthletes = () => {
            let api = new Api();
            api.getAthletes().then((data) => {
                setAthletes((n) => data);
            });
        };

    useEffect(() => {
        if (nations.length == 0)
        {
            let api = new Api();
            api.getNations().then((data) => {
                setNations((n) => data);
            });
        }

         if (athletes.length == 0)
        {
            updateAthletes();
        }
      
    },[]);
     

    let filteredAthletes = athletes ? athletes : [] as Athlete[];

    if (natFilter) {
        filteredAthletes = filteredAthletes.filter(x => { return x.nationality.toLowerCase().startsWith(natFilter.toLowerCase()) });
    }
    if (athFilter) {
        filteredAthletes = filteredAthletes.filter(x => { return x.firstName.toLowerCase().startsWith(athFilter.toLowerCase()) || x.lastName.toLowerCase().startsWith(athFilter.toLowerCase()) });
    }



    return <Stack style={{ padding: 10 }}>
        <Stack direction={"row"} spacing={2}>
            <TextField placeholder='Nation' label="Nation" value={natFilter} onChange={(ev) => { setNatFilter(ev.target.value) }} />
            <TextField placeholder='Name' label="Name" value={athFilter} onChange={(ev) => { setAthFilter(ev.target.value) }} />
        </Stack>
        <Grid container spacing={2}>
            <Grid item xs={2}>
                <Button style={{marginLeft:10, marginTop: 10}} onClick={() => {
                    var ath = new Athlete();
                    ath.firstName = "FirstName";
                    ath.lastName = "LastName";
                    ath.nationality="Nation";
                    ath.id = new Date().getTime()+"";
                    ath.prone = {name:"",pattern: "-----"};
                    ath.standing = {name:"",pattern: "-----"};

                    setShowAddAthlete(ath);}}>Add New</Button>
                <List sx={{
                    overflow: 'auto',
                    maxHeight: 700
                }}>
                    {filteredAthletes && filteredAthletes.map((ath) => {
                        return <ListItem disablePadding>
                            <ListItemButton selected={ath.id == selAthlete?.id} onClick={() => {
                                setSelAthlete(ath)
                            }}>
                                <ListItemText key={ath.id} primary={ath.firstName + " " + ath.lastName} /></ListItemButton></ListItem>;
                    })}
                </List>
            </Grid>
            <Grid item xs={10}>
                {!showAddAthlete && selAthlete && <AthleteDisplay athlete={selAthlete} />}
                {showAddAthlete && <AddAthlete close={() => {
                    updateAthletes();
                    setShowAddAthlete(null)}} athlete={showAddAthlete}  />}
            </Grid>
        </Grid>

    </Stack>;
}
export default ListAllAthletes;